import { TransTokens } from "./trans-tokens";

export const CoreTokens = TransTokens.create({
  profile: "Profile",
  yourAccount: "Your account",
  loggedInAs: "Logged in as {{user.name}}",
  accountSettings: "Account settings",
  yourScore: "Your score",
  leaderboard: "Leaderboard",
  continue: "Continue",
  skip: "Skip",
  skipSure: "Are you sure you want to skip to the next scene?",
  close: "Close",
  ok: "Ok",
  yes: "Yes",
  no: "No",
  cancel: "Cancel",
  tryAgain: "Try again",
  notLoggedIn: "You are not logged in.",
  letsGo: "Let's go",
  previousStep: "Previous step",
  play: "Play",
  name: "Name",
  loading: "Loading",
  points: "Points",
  login: "Log in",
  logout: "Log out",
  nA: "n/a",
  settings: "Settings",
  helpSupport: "Help & Support",
  gettingStarted: "Getting started",
  help: "Help",
  aboutUnlockables: "About unlockables",
  privacyPolicy: "Privacy policy",
  termsOfService: "Terms of service",
  cookiePolicy: "Cookie policy",
  customPolicy: "Policy document",
  statementOfConsent: "Statement of consent",
  compassInstructions: "Compass instructions",
  hide: "Hide",
  show: "Show",
  instructions: "Instructions",
  areYouSure: "Are you sure?",
  areYouSureBody: "Are you sure you want to perform this action?",
  somethingWrong: "Something went wrong.",
  somethingWrongMessage:
    "An error occurred while loading this content. Please check your internet connection and tap below to try again.",
  unknown: "Unknown",
  unlockChallenge: "Unlock a challenge",
  unknownError: "An unknown error occurred, please try again later.",
  startOver: "Restart",
  quit: "Quit",
  reload: "Reload",
  clearAll: "Clear all",
  selectAll: "Select all",
  stories: "stories",
  startOverConfirm:
    "Do you really want to start from the beginning? Warning: you will lose all of your progress!",
  agree: "Agree",
  disagree: "Disagree",
  typeAnswerHere: "Type your answer here...",
  you: "You",
  submit: "Submit",
  start: "Start",
  disconnectEnvironment: "Disconnect environment",
  language: "Language",
  goBack: "Go back",
  verifying: "Verifying",
  makeChoice: "Pick an option to continue",
  featureNotSupported:
    "This feature is not supported by your current app version.",
  answers: "answers",
  answer: "answer",
  selected: "selected",
  apply: "Apply",
  shareStory: "Share Story",
  copyLink: "Copy Link",
  linkCopied: "Link Copied!",
  shareToWhatsApp: "Share to WhatsApp",
  otherShareOptions: "Other share options",
  downloadImage: "Download",
});

export const NicknameTokens = TransTokens.create({
  strangerTitle: "Hello there!",
  strangerBody: "Please enter a nickname for the leaderboard",
  knownTitle: "Change your nickname",
  knownBody: "How would you like to be known in the leaderboard?",
  placeholder: "Type your nickname...",
});

export const EmailLoginTokens = TransTokens.create({
  login: "Please enter your email address and we'll send you a login link",
  loginProfessional: "Please enter your email address",
  mailAddressProfessional: "Your email address",
  mailAddress: "Your email address",
  name: "Your name",

  goBack: "Go back to the main screen",

  privacyServiceAgree:
    "Yes, I agree to the [privacy policy]({{privacy}}) and [terms of service]({{terms}}).",

  privacyServiceAndConsentAgree:
    "Yes, I agree to the [privacy policy]({{privacy}}) and [terms of service]({{terms}}) and I have read the [statement of consent]({{consent}}).",
  soloPrivacyAgree: "Yes, I agree to the [privacy policy]({{privacy}}).",
  soloTermsAgree: "Yes, I agree to the [terms of service]({{terms}}).",
  soloConsentAgree:
    "Yes, I agree with the [statement of consent]({{consent}}) and give permission for the processing of my personal data for this vitality program.",
});

export const EmailVerifyTokens = TransTokens.create({
  mailSent: "An email with a login link has been sent to {{mail}}.",
  tokenAlternative:
    "Don't have access to your email on this device? Use the verification code instead.",
  code: "Verification code",
  goBack: "Use a different e-mail address",
  verifyError: "Could not sign-in",
});

export const EventTokens = TransTokens.create({
  leftSpots: "{{remaining}} spots left",
  leftSpot: "{{remaining}} spot left",
  participantsUnlimited: "Many spots available",
  availability: "Availability",
  waitingList: "Full (waiting list)",
  eventFull: "Full",
  untilDateOrTime: "until {{dateOrTime}}",
  subscribeError:
    "Could not subscribe to event due to a problem, please try again later.",
  unsubscribe: "Unsubscribe",
  beTheFirst: "No one yet, be the first!",
  unsubscribeConfirm: "Are you sure you want to unsubscribe from this event?",
  unsubscribeConfirmWaitingList:
    "Are you sure you want to unsubscribe from this event? If there are people on the waiting list, your spot will go to them.",
  unsubscribeConfirmWaiting: "You will lose your spot on the waiting list!",
  youAreAttending: "You are attending",
  hostedBy: "Hosted by {{userName}}",
  location: "Location",
  unknown: "Unknown",
  demio: "Webinar via demio.com",
  webinarGeek: "Webinar via WebinarGeek",
  linkWebinar: "Join the session now",
  attending: "Attending",
  eventInProgress: "In progress",
  eventFinished: "Finished",
  sessionFinished: "Session finished",
  eventStartsSoon: "Starts soon",
  onWaitingList: "On waiting list",
  date: "Date",
  wantToJoin: "I want to join",
  wantToJoinWaitingList: "Join waiting list",
  dateAndTime: "Choose date and time",
  registered: "You have successfully registered for {{eventName}}.",
  joinedWaitingList:
    "You have been added to the waiting list for {{eventName}}.",
  currentlyNoOptions: "Currently no options available",
});

export const AccountPageTokens = TransTokens.create({
  actions: "Actions",
  changePicture: "Change picture",
  changeNickname: "Change nickname",
  warning: "WARNING!",
  removeAccount: "Remove account",
  removeAccountConfirm:
    "Are you sure you want to remove your account? All your scores, reviews, content and progress will also be removed.",
  removeAccountYes: "Yes, I'm sure",
  dangerZone: "Danger zone",
  screenName: "Your display name",
  screenNameRequired: "Your display name (required)",

  hideScreenName: "I prefer to participate in live events anonymously",
  accountSetupTitle: "Set up your account",
  accountSetupDescription:
    "Almost there! Fill out the fields below to complete your profile.",
  preferredLanguage: "Your preferred language",
  selectDepartment: "Select your work context below",
  selectDepartmentPlaceholder: "Select your work context",
});

export const StoryDashboardTokens = TransTokens.create({
  allCategories: "All categories",
  searchCategories: "Search categories...",
  noResults: "No categories found",
  selectCategories: "Select categories",
});
